// Computes a delay (ms) for an element at `progress` (0–1) so the stagger sequence
// follows the same cubic-bezier(0.16, 1, 0.3, 1) spring curve used by bar-grow tailwind keyframes.
// y1=y2=1 gives the closed-form inverse: t = 1 - ∛(1-progress), then x(t) is
// evaluated with the standard bezier formula using x1=0.16, x2=0.3.
export const springDelay = (progress: number, totalDuration: number): number => {
    if (progress <= 0) return 0
    if (progress >= 1) return totalDuration
    const t = 1 - Math.pow(1 - progress, 1 / 3)
    const x = 3 * (1 - t) ** 2 * t * 0.16 + 3 * (1 - t) * t ** 2 * 0.3 + t ** 3
    return x * totalDuration
}
